import { siteInfo } from '@/mocks/news';

export default function FeatureGrid() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-primary-400/30 bg-primary-500/5 mb-4">
            <i className="ri-star-line text-primary-400 text-xs"></i>
            <span className="text-primary-400 text-xs font-medium">为什么选择我们</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            平台四大特色
          </h2>
          <p className="mt-3 text-foreground-400 text-sm max-w-lg mx-auto">
            用心做好每一个细节，为吃瓜群众提供最好的体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {siteInfo.features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-50 border border-foreground-200/15 rounded-xl p-7 transition-all duration-300 hover:bg-primary-500 hover:border-primary-500 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-foreground-950/5 group-hover:bg-foreground-950/20 transition-colors duration-300 mb-5">
                <i className={`${feature.icon} text-2xl text-primary-400 group-hover:text-foreground-950 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-800 group-hover:text-foreground-950 transition-colors duration-300 mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-400 text-sm leading-relaxed group-hover:text-foreground-800 transition-colors duration-300">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}